import { BizEntityTypeCategory, BizInformationTypes, FieldTypes, IBizEntity, IUser } from "@optima-stride-ai/core";
import { AvatarComponent, EventSources, ExplorerInterceptsFor, IListViewColHeader, IListViewItem } from "@optima-stride-ai/optima-components";
import { showFeatureNotImplemented } from "../utils/util.service";
import { ColumnCanonicalKeys } from "../strategy/explorer-list-view";

export function getListViewForMeasureEntity(data: any, contextMenu: (item: IListViewItem<IBizEntity> | undefined, event?: Event | undefined) => void, drillDown: (itemId: string) => void, addMeasureLogAction: (item: IListViewItem<IBizEntity> | undefined, event?: Event | undefined) => void, selectClickedITem: (itemId: string) => void, isInModal: boolean): IListViewItem<IBizEntity>[] {
    let items: IListViewItem<IBizEntity>[] = [];
    for (let i = 0; i < data.length; i++) {
        let d = data[i];
        let optionIcon = 'cilOptions'
        let menuToolTIp = 'Action'
        let addIcon = 'cilPlus'
        // let directionIcon = d.direction === 0 ? 'optimaArrowDiagonalUp' : 'optimaArrowDiagonalDown';
        // let directionStyleColor = d.direction === 0 ? 'color: green' : 'color: red';
        let action;
        if (isInModal) {
            if (d.type.category === BizEntityTypeCategory.BenzaitenMeasure) {
                action = { label: 'itemClicked', icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => { } }
            }
            else {
                action = {
                    label: `itemClicked`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                        if (item?.id) {
                            drillDown(item.id);
                        }
                    }, eventSource: EventSources.DoubleClick, interceptableFor: ExplorerInterceptsFor.HierarchyItemSelection
                };
            }
        } else {
            action = {
                label: `itemClicked`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                    if (item?.id) {
                        drillDown(item.id);
                    }
                }, eventSource: EventSources.DoubleClick, interceptableFor: ExplorerInterceptsFor.HierarchyItemSelection
            };
        }

        let item: IListViewItem<IBizEntity> = {
            id: d.id,
            itemActions: [
                {
                    label: `selectItem`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                        if (item?.id) {
                            selectClickedITem(item.id);
                        }
                    }, eventSource: EventSources.Click
                },
                action

            ],
            columns: d.type.category !== BizEntityTypeCategory.BenzaitenMeasure ? [
                { key: ColumnCanonicalKeys.Icon, label: 'L1', value: d.icon, metaData: { name: 'icon', label: 'L1', type: FieldTypes.text }, bizInformationType: BizInformationTypes.icon },
                { key: ColumnCanonicalKeys.Name, label: 'L1', value: d.name, metaData: { name: 'name', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Type, label: 'L2', value: d.type.name, metaData: { name: 'type.name', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Owner, label: 'L7', value: {component: AvatarComponent, inputs: { users: d.ownerDetail, size: 'md', viewType: 'single', onMessage: (user: IUser) => showFeatureNotImplemented('Messaging'), onCall: (user: IUser) => showFeatureNotImplemented('Call') }}, metaData: { name: 'owner', label: 'L7', type: FieldTypes.component }, bizInformationType: BizInformationTypes.component },
            ] : [
                { key: ColumnCanonicalKeys.Icon, label: 'L1', value: d.icon, metaData: { name: 'icon', label: 'L1', type: FieldTypes.text }, bizInformationType: BizInformationTypes.icon },
                { key: ColumnCanonicalKeys.Name, label: 'L1', value: d.name, metaData: { name: 'name', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Type, label: 'L2', value: d.type.name, metaData: { name: 'type.name', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Group, label: 'L3', value: d.group ? d.group + '/' + d.subGroup : '', metaData: { name: 'subgroup', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Category, label: 'L4', value: d.category, metaData: { name: 'category', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: ColumnCanonicalKeys.Owner, label: 'L7', value: {component: AvatarComponent, inputs: { users: d.ownerDetail, size: 'md', viewType: 'single', onMessage: (user: IUser) => showFeatureNotImplemented('Messaging'), onCall: (user: IUser) => showFeatureNotImplemented('Call') }}, metaData: { name: 'owner', label: 'L7', type: FieldTypes.component }, bizInformationType: BizInformationTypes.component },
            ],
            actions: !isInModal ? [
                ...(d.type.category === BizEntityTypeCategory.BenzaitenMeasure ?
                    [{ label: 'Add', icon: addIcon, tooltip: 'Add Measure Log', action: addMeasureLogAction }] : []),
                { label: 'Menu', icon: optionIcon, tooltip: menuToolTIp, action: contextMenu, interceptableFor: ExplorerInterceptsFor.ContextMenu }
            ] : [],


        };
        items.push(item);
    }
    return items;
}

export function getListViewForTxnEntities(data: any, contextMenu: (item: IListViewItem<IBizEntity> | undefined, event?: Event | undefined) => void, drillDown: (itemId: string) => void, addMeasureLogAction: (item: IListViewItem<IBizEntity> | undefined, event?: Event | undefined) => void, selectClickedITem: (itemId: string) => void, isInModal: boolean): IListViewItem<IBizEntity>[] {
    let items: IListViewItem<IBizEntity>[] = [];
    for (let i = 0; i < data.length; i++) {
        let d = data[i];
        let optionIcon = 'cilOptions'
        let menuToolTIp = 'Action'
        let addIcon = 'cilPlus'
        // let directionIcon = d.direction === 0 ? 'optimaArrowDiagonalUp' : 'optimaArrowDiagonalDown';
        // let directionStyleColor = d.direction === 0 ? 'color: green' : 'color: red';
        let action;
        if (isInModal) {
            if (d.type.category === BizEntityTypeCategory.BenzaitenMeasure) {
                action = { label: 'itemClicked', icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => { } }
            }
            else {
                action = {
                    label: `itemClicked`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                        if (item?.id) {
                            drillDown(item.id);
                        }
                    }, eventSource: EventSources.DoubleClick, interceptableFor: ExplorerInterceptsFor.HierarchyItemSelection
                };
            }
        } else {
            action = {
                label: `itemClicked`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                    if (item?.id) {
                        drillDown(item.id);
                    }
                }, eventSource: EventSources.DoubleClick, interceptableFor: ExplorerInterceptsFor.HierarchyItemSelection
            };
        }

        let item: IListViewItem<IBizEntity> = {
            id: d.id,
            itemActions: [
                {
                    label: `selectItem`, icon: '', action: (item: IListViewItem<IBizEntity> | undefined) => {
                        if (item?.id) {
                            selectClickedITem(item.id);
                        }
                    }, eventSource: EventSources.Click
                },
                action

            ],
            columns: d.type.category !== BizEntityTypeCategory.Transactional ? [
                { key: 'col1', label: 'L1', value: d.icon, metaData: { name: 'col1', label: 'L1', type: FieldTypes.text }, bizInformationType: BizInformationTypes.icon },
                { key: 'col2', label: 'L2', value: d.name, metaData: { name: 'col2', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: 'col3', label: 'L3', value: d.type.name, metaData: { name: 'col3', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: 'col7', label: 'L7', value: {component: AvatarComponent, inputs: { users: d.ownerDetail, size: 'md', viewType: 'single', onMessage: (user: IUser) => showFeatureNotImplemented('Messaging'), onCall: (user: IUser) => showFeatureNotImplemented('Call') }}, metaData: { name: 'col7', label: 'L7', type: FieldTypes.component }, bizInformationType: BizInformationTypes.component },
            ] : [
                { key: 'col1', label: 'L1', value: d.icon, metaData: { name: 'col1', label: 'L1', type: FieldTypes.text }, bizInformationType: BizInformationTypes.icon },
                { key: 'col2', label: 'L2', value: d.name, metaData: { name: 'col2', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: 'col3', label: 'L3', value: d.type.name, metaData: { name: 'col3', label: '', type: FieldTypes.text }, bizInformationType: BizInformationTypes.text },
                { key: 'col7', label: 'L7', value: {component: AvatarComponent, inputs: { users: d.ownerDetail, size: 'md', viewType: 'single', onMessage: (user: IUser) => showFeatureNotImplemented('Messaging'), onCall: (user: IUser) => showFeatureNotImplemented('Call') }}, metaData: { name: 'col7', label: 'L7', type: FieldTypes.component }, bizInformationType: BizInformationTypes.component },
            ],
            actions: !isInModal ? [
                ...(d.type.category === BizEntityTypeCategory.Transactional ?
                    [{ label: 'Add', icon: addIcon, tooltip: `Add ${d.name} Log`, action: addMeasureLogAction }] : []),
                { label: 'Menu', icon: optionIcon, tooltip: menuToolTIp, action: contextMenu, interceptableFor: ExplorerInterceptsFor.ContextMenu }
            ] : [],


        };
        items.push(item);
    }
    return items;
}